import { SpeedDial } from "@mui/material";
import styled from "styled-components";

const MRSpeedDial = styled(SpeedDial)``;

export default MRSpeedDial;
